export default __webpack_public_path__ + "images/A6.7764310.png";